'use strict';

var _ = require('lodash');
var LocoFareHeatmapGridAggregationFactory = function LocoFareHeatmapGridAggregationFactory(DataAggregationFactory) {
  function LocoFareHeatmapGridAggregation() {
    DataAggregationFactory.call(this, 'rom-analysis-loco-mode', 'loco-fare-heatmap');
  }
  LocoFareHeatmapGridAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  LocoFareHeatmapGridAggregation.constructor = LocoFareHeatmapGridAggregation;
  LocoFareHeatmapGridAggregation.prototype.aggregate = function (data) {
    var aggregatedLoco = [],
      map = [];
    var results = [];
    for (var i = 0; i < data.length; i++) {
      var record = data[i];
      var mapIndex = map.indexOf(record.departureDate);
      var rangeName = 'range' + record.romTimeBucket;
      var loco;
      var fareFraction = {};
      if (mapIndex === -1) {
        loco = {
          departureDateMoment: record.departureDateMoment,
          dow: record.dow
        };
        fareFraction[rangeName] = {
          nominator: record.fareGap * record.demand,
          denominator: record.demand,
          sum: record.fareGap,
          quantity: 1
        };
        results.push(fareFraction);
        aggregatedLoco.push(loco);
        map.push(record.departureDate);
      } else {
        if (results[mapIndex][rangeName] === undefined) {
          results[mapIndex][rangeName] = {
            nominator: record.fareGap * record.demand,
            denominator: record.demand,
            sum: record.fareGap,
            quantity: 1
          };
        } else {
          results[mapIndex][rangeName].nominator += record.fareGap * record.demand;
          results[mapIndex][rangeName].denominator += record.demand;
          results[mapIndex][rangeName].sum += record.fareGap;
          results[mapIndex][rangeName].quantity++;
        }
      }
    }
    _.forEach(results, function (result, index) {
      var recalculatedResult = [];
      _.forOwn(result, function (range, key) {
        if (range.denominator <= 0) {
          recalculatedResult[key] = range.sum / range.quantity;
        } else {
          recalculatedResult[key] = range.nominator / range.denominator;
        }
      });
      _.assign(aggregatedLoco[index], recalculatedResult);
    });
    return aggregatedLoco;
  };
  return LocoFareHeatmapGridAggregation;
};
LocoFareHeatmapGridAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = LocoFareHeatmapGridAggregationFactory;